<template>
    <div class="margin-settings text-center">

            <div class="btnGroup" >
            </div>
            
            <div style="border:1px dashed lightgrey;text-align:center;display:inline-block;">
                <table>
                    <tbody>
                        <tr>
                            <td></td>
                            <td>
                                <drag-input-unit 
                                	:value='styleJSON.marginTop' 
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-top"
                                	@input="(value)=>{
                                		setStyle({marginTop:value});
                                		if(currentGroup === 1){
                                			setStyle({marginBottom:value});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				marginLeft:value,
                                				marginBottom:value,
                                				marginRight:value
                                			});
                                		}
                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <drag-input-unit 
                                	:value='styleJSON.marginLeft' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-left"
                                	@input="(value)=>{
                                		setStyle({marginLeft:value});
                                		if(currentGroup === 1){
                                			setStyle({marginRight:value});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				marginTop:value,
                                				marginBottom:value,
                                				marginRight:value
                                			});
                                		}
                                	}" 
                                />
                            </td>
                            <td>
                                <div style="border:1px solid grey;padding:6px 6px;display:inline-block;">
                <btn 
                    v-for="(icon,index) in ['expand','arrows','square']" 
                    :key="index"
                    :icon="icon" 
                    s="xs" 
                    :active="currentGroup === index" 
                    @press="currentGroup = index" 
                />
                                </div>
                            </td>
                            <td >
                                <drag-input-unit 
                                	:value='styleJSON.marginRight' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-right"
                                	@input="(value)=>{
                                		setStyle({marginRight:value});
                                		if(currentGroup === 1){
                                			setStyle({marginLeft:value});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				marginLeft:value,
                                				marginBottom:value,
                                				marginTop:value
                                			});
                                		}
                                	}"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <drag-input-unit 
                                	:value='styleJSON.marginBottom' 
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-bottom"
                                	@input="(value)=>{
                                		setStyle({marginBottom:value});
                                		if(currentGroup === 1){
                                			setStyle({marginTop:value});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				marginLeft:value,
                                				marginRight:value,
                                				marginTop:value
                                			});
                                		}

                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>


    </div>
</template>
<script>
export default {
    name: "margin-settings",
    data() {
        return {
            currentGroup: 0
        }
    },
    props: {
        setStyle: Function,
        styleJSON: {type:Object,default:{value:0, unit:'px'}}
    }
}
</script>
<style scoped>
.btnGroupVertical .btn {
    width: 18px;
}
</style>